export const getLogoByTheme = (isForcedDarkMode?: boolean) =>
  typeof document !== 'undefined' &&
  (isForcedDarkMode || document.body.classList.contains('chakra-ui-dark'))
    ? '/assets/eqiplus-logo-dark.png'
    : '/assets/eqiplus-logo.png';
